const worker = new Worker(new URL('./compile-worker.js', import.meta.url));
let id = 0;
export const compileCode = (code, lang) => new Promise((fulfill) => {
    const messageId = id++;
    const compileEvent = {
        messageId,
        lang,
        source: code,
    };
    worker.postMessage(compileEvent);
    function handleMessage(ev) {
        const data = ev.data;
        if (messageId === data.messageId) {
            fulfill(data);
            worker.removeEventListener('message', handleMessage);
        }
    }
    worker.addEventListener('message', handleMessage);
});
//# sourceMappingURL=compile-code.js.map